<template>
  <member-not-found-error
    v-if="memberNotFound"
    :action="redirectToSignup"
  />
  <div
    v-else
    class="login-enter-code"
  >
    <riseup-header>
      <div class="ri-bold-body">
        כניסה
      </div>
    </riseup-header>
    <div class="page padding-top-ml">
      <div class="content">
        <div class="ri-medium-bold-headline">
          מה הקוד החד פעמי שקיבלת?
        </div>
        <enter-code
          :phone-number="phoneNumber"
          :confirm-code-action="onCodeEntered"
          :regenerate-code-action="() => authenticationStore.generateCode(normalizedPhoneNumber, true)"
          :server-error="errorLabel"
          :button-title="'אישור'"
          :loading="loading || authLoading"
          :reset-error="resetError"
        />
      </div>
      <support-footer class="login-footer margin-bottom-l" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import RiseupHeader from '@riseupil/base-ui/src/components/RiseupHeader.vue';
import SupportFooter from '@riseupil/base-ui/src/components/SupportFooter.vue';
import _ from 'lodash';
import EnterCode from './EnterCode.vue';
import { useLoginStore } from '../../stores/login';
import { useAuthenticationStore } from '../../stores/authentication';
import Segment from '../../Segment';
import { parseAuthenticationError } from '../../utils/LoginErrorParser';
import MemberNotFoundError from './MemberNotFound.vue';

const errorLabel = ref<string>('');
const route = useRoute();
const router = useRouter();
const loginStore = useLoginStore();
const authenticationStore = useAuthenticationStore();
const { phoneNumber, normalizedPhoneNumber, loading, memberNotFound } = storeToRefs(loginStore);
const { loading: authLoading } = storeToRefs(authenticationStore);
Segment.trackUserGot('Login_EnterCode_Shown');

loginStore.setPhoneNumber(route.query.phoneNumber as string || '');
function resetError() {
  errorLabel.value = '';
}
const onCodeEntered = async (code: string) => {
  try {
    const { riseupAccountId, challenger, memberId } = await authenticationStore.authenticate(normalizedPhoneNumber.value, code);
    await loginStore.login(riseupAccountId, challenger, memberId);
    await continueAfterLogin();
  } catch (e) {
    errorLabel.value = parseAuthenticationError(e);
    Segment.trackUserGot('Login_EnterCode_Error', { errorLabel: errorLabel.value });
  }
};

const continueAfterLogin = async () => {
  // Attention! this code is also duplicated in Signup.vue
  const redirectTo = route.query.redirectTo as string;
  const queryParams = _.pickBy(route.query, (value, key) => _.startsWith(key, 'utm_'));
  await router.push({ path: decodeURIComponent(redirectTo), query: queryParams });
};

const redirectToSignup = async () => {
  router.push({ path: '/signup', query: route.query });
};
</script>

<style lang="scss" scoped>
@import 'base-ui-vue3/src/scss/riseup-colors';
@import '@riseupil/base-ui/src/scss/mixins';

  .login-enter-code {
    @include white-page-frame;
    height: 100%;
    .page {
      @include white-page-frame;
      @include responsive-padding;
      height: 100%;
      justify-content: space-between;
      .content {
        width: 100%;
      }
      .login-footer {
        text-align: center;
      }
    }
  }
</style>
